import React, {  } from 'react';
import { TitleTree } from '../../domain/domain';
import NodeTitle from './NodeTitle';
import TitleTreeItem from './TitleTreeItem';

type Props = {
    parent: TitleTree,
    itemRoot: TitleTree,
    onNodeClicked: (node: TitleTree) => void,
    onContextMenu: (event: any, tree: TitleTree) => void
}

const TitleTreeItemComponent: React.FC<Props> = ({ parent, itemRoot, onNodeClicked, onContextMenu }) => {
    const item = null;
    const opacity = (item !== null && (item as any).nodeId === itemRoot.nodeId) ? 0.4 : 1;

    let sortedChildren = itemRoot.children.sort((child1, child2) => {
        return child1.ordinal - child2.ordinal
    })

    return (
        <TitleTreeItem
            key={itemRoot.nodeId}
            nodeId={"" + itemRoot.nodeId}
            style={{ opacity: opacity }}
            onLabelClick={(_) => { onNodeClicked(itemRoot) }}
            onContextMenu={(event: React.MouseEvent) => onContextMenu(event, itemRoot)}
            label={
                <NodeTitle nodeId={itemRoot.nodeId} />
            }
        >
            {sortedChildren.map((c: TitleTree, idx: number) => {
                return <TitleTreeItemComponent key={idx} parent={itemRoot} itemRoot={c} onNodeClicked={onNodeClicked} onContextMenu={onContextMenu} />
            })}
        </TitleTreeItem>
    )
}

export default TitleTreeItemComponent;